export const executionAdminRoutes = [
  {
    path: "/instance-center",
    name: "instanceCenter",
    icon: "cluster",
    access: "canManageExecution",
    routes: [
      {
        path: "",
        redirect: "/instance-center/dashboard",
      },
      {
        path: "dashboard",
        name: "instanceDashboard",
        icon: "dashboard",
        component: "./platform-instance/DashboardPage",
      },
      {
        path: "vm-instances",
        name: "instanceVmInstances",
        icon: "desktop",
        component: "./platform-instance/VmInstancesPage",
      },
      {
        path: "container-instances",
        name: "instanceContainerInstances",
        icon: "container",
        component: "./platform-instance/ContainerInstancesPage",
      },
      {
        path: "vm-instances/:instanceNo",
        component: "./platform-instance/VmInstanceDetailPage",
      },
      {
        path: "container-instances/:instanceNo",
        component: "./platform-instance/ContainerInstanceDetailPage",
      },
      {
        path: "topology-instances",
        name: "instanceTopologyInstances",
        icon: "deploymentUnit",
        component: "./platform-instance/TopologyInstancesPage",
      },
      {
        path: "topology-instances/:topologyInstanceNo",
        component: "./platform-instance/TopologyInstanceDetailPage",
      },
      {
        path: "remote-sessions",
        name: "instanceRemoteSessions",
        icon: "link",
        component: "./platform-instance/RemoteSessionsPage",
      },
      {
        path: "user-virtualization-quotas",
        name: "instanceUserVirtualizationQuotas",
        icon: "pieChart",
        routes: [
          {
            path: "",
            redirect: "/instance-center/user-virtualization-quotas/users",
          },
          {
            path: "users",
            name: "instanceUserVirtualizationQuotaUsers",
            icon: "team",
            component: "./platform-instance/UserVirtualizationQuotaUsersPage",
          },
          {
            path: "policy",
            name: "instanceUserVirtualizationQuotaPolicy",
            icon: "control",
            component: "./platform-instance/UserVirtualizationQuotaPolicyPage",
          },
          {
            path: "profiles",
            name: "instanceUserVirtualizationQuotaProfiles",
            icon: "profile",
            component:
              "./platform-instance/UserVirtualizationQuotaProfilesPage",
          },
          {
            path: "leases",
            name: "instanceUserVirtualizationQuotaLeases",
            icon: "audit",
            component: "./platform-instance/UserVirtualizationQuotaLeasesPage",
          },
        ],
      },
    ],
  },
  {
    path: "/orchestrator-center",
    name: "orchestratorCenter",
    icon: "rocket",
    access: "canManageExecution",
    routes: [
      {
        path: "",
        redirect: "/orchestrator-center/dashboard",
      },
      {
        path: "dashboard",
        name: "orchestratorDashboard",
        icon: "dashboard",
        component: "./platform-orchestrator/DashboardPage",
      },
      {
        path: "capability-map",
        name: "orchestratorCapabilityMap",
        icon: "apartment",
        component: "./platform-orchestrator/CapabilityMapPage",
      },
      {
        path: "requests",
        name: "orchestratorRequests",
        icon: "fileSearch",
        component: "./platform-orchestrator/RequestsPage",
      },
      {
        path: "recycles",
        name: "orchestratorRecycles",
        icon: "delete",
        component: "./platform-orchestrator/RecyclesPage",
      },
      {
        path: "actions",
        name: "orchestratorActions",
        icon: "playCircle",
        component: "./platform-orchestrator/ActionsPage",
      },
    ],
  },
  {
    path: "/execution-center",
    name: "executionCenter",
    icon: "api",
    access: "canManageExecution",
    routes: [
      {
        path: "",
        redirect: "/execution-center/dashboard",
      },
      {
        path: "dashboard",
        name: "executionDashboard",
        icon: "dashboard",
        component: "./platform-execution/DashboardPage",
      },
      {
        path: "scheduling",
        name: "executionScheduling",
        icon: "control",
        component: "./platform-execution/SchedulingPage",
      },
      {
        path: "instances",
        name: "executionInstances",
        icon: "desktop",
        component: "./platform-execution/InstancesPage",
      },
      {
        path: "targets",
        name: "executionTargets",
        icon: "compass",
        component: "./platform-execution/TargetsPage",
      },
      {
        path: "providers",
        name: "executionProviders",
        icon: "api",
        component: "./platform-execution/ProvidersPage",
      },
      {
        path: "nodes",
        name: "executionNodes",
        icon: "cluster",
        component: "./platform-execution/NodesPage",
      },
      {
        path: "node-heartbeats",
        name: "executionNodeHeartbeats",
        icon: "heart",
        component: "./platform-execution/NodeHeartbeatsPage",
      },
      {
        path: "docker",
        name: "executionDocker",
        icon: "container",
        component: "./platform-execution/DockerPage",
      },
      {
        path: "vm",
        name: "executionVm",
        icon: "desktop",
        component: "./platform-execution/VmPage",
      },
    ],
  },
  {
    path: "/task-center",
    name: "taskCenter",
    icon: "profile",
    access: "canManageExecution",
    routes: [
      {
        path: "",
        redirect: "/task-center/dashboard",
      },
      {
        path: "dashboard",
        name: "taskCenterDashboard",
        icon: "dashboard",
        component: "./platform-task-center/DashboardPage",
      },
      {
        path: "tasks",
        name: "taskCenterTasks",
        icon: "profile",
        component: "./platform-task-center/TasksPage",
      },
      {
        path: "events",
        name: "taskCenterEvents",
        icon: "notification",
        component: "./platform-task-center/EventsPage",
      },
      {
        path: "raw-events",
        redirect: "/task-center/events",
      },
      {
        path: "error-codes",
        name: "taskCenterErrorCodes",
        icon: "warning",
        component: "./platform-task-center/ErrorCodesPage",
      },
    ],
  },
];
